<template>
    <div class="float-left">
        <b-modal
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
            @show="preencher()"
            @close="fecharModal()"
        >
            <div slot="modal-title">
                Centros de Custos -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Centro de Custo</label>
                        <b-form-select
                            :options="cCustos"
                            v-model="comprometimento.codCCusto"
                            text-field="nomeCodCCusto"
                            value-field="codCCusto"
                            @input="$v.cCusto.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="parcela">Parcela</label>
                        <b-input-group>
                            <b-form-select
                                id="parcela"
                                type="text"
                                :options="convenio.cronogramasDesembolsos"
                                value-field="idCronogramaDesembolso"
                                text-field="nuParcela"
                                v-model="comprometimento.idCronogramaDesembolso"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback>Parcela é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                 <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="nuValorRateio">Valor Rateio</label>
                        <b-input-group>
                            <money
                                id="nuValorRateio"
                                v-model="comprometimento.nuValorRateio"
                                v-bind="money"
                                class="form-control text-right"
                            ></money>
                            <b-form-invalid-feedback>Parcela é obrigatória</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../ConveniosServicos'

export default {

    props: {
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        convenio: Object,
        comprometimento: Object,
        desativarBotao: Boolean
    },

    validations: {
        comprometimento: {
            nuValorRateio: { required, minValue: minValue(0.01) },
            codCCusto: { required }
        }
    },

    data() {
        return {
            // unidades: [],
            // projetos: [],
            // acoes: [],
            // vcCodAcao:null,
            // vcCodProjeto:null,
            // vcCodUnidade:null,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            cCustos: [],
            preenchido: false,
            comprometimento:{
                idRateioComprometimento:0,
                idCronogramaDesembolso:0,
                nuValorRateio:0,
                nomeCCusto: null,
                codCCusto: null,
            }
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.idRateioComprometimento = this.comprometimento.idRateioComprometimento
                this.idCronogramaDesembolso = this.comprometimento.idCronogramaDesembolso
                this.nuValorRateio = this.comprometimento.nuValorRateio
                this.ccodCCusto = this.comprometimento.ccodCCusto
                this.preenchido = true
            }
        },

        // obterUnidades(){
        //     this.$store.dispatch('addRequest')
        //     ConveniosServicos.obterUnidades().then(
        //         response => {
        //             if (response) {
        //                 if (response.success) {
        //                     this.unidades = response.data
        //                 } else {
        //                     this.erros = response.errors
        //                 }
        //             }
        //             this.$store.dispatch('removeRequest')
        //         }
        //     )
        // },

        // obterProjetos(){
        //     this.$store.dispatch('addRequest')
        //     ConveniosServicos.obterProjetosPorUnidade(this.vcCodUnidade).then(
        //         response => {
        //             if (response) {
        //                 if (response.success) {
        //                     this.projetos = response.data
        //                 } else {
        //                     this.erros = response.errors
        //                 }
        //             }
        //             this.$store.dispatch('removeRequest')
        //         }
        //     )
        // },

        // obterAcoes(){
        //     this.$store.dispatch('addRequest')
        //     ConveniosServicos.obterAcoesPorProjeto(this.vcCodProjeto).then(
        //         response => {
        //             if (response) {
        //                 if (response.success) {
        //                     this.acoes = response.data
        //                 } else {
        //                     this.erros = response.errors
        //                 }
        //             }
        //             this.$store.dispatch('removeRequest')
        //         }
        //     )
        // },
        
        obterCCustos() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterCCustos().then(response => {
                if (response) {
                    if (response.success) {
                        this.cCustos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },


        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        salvar() {
            console.log('aq entrou')
            this.comprometimento.idConvenio = this.$route.params.convenioId
            this.comprometimento.nomeCCusto = this.cCustos.find(x => x.codCCusto == this.comprometimento.codCCusto).nomeCCusto
            this.$emit('salvar', this.comprometimento)
            this.$emit('atualizarListaComprometimentos')
            this.resetar()
        },

        resetar() {
                this.comprometimento.nuValorRateio = 0,
                this.comprometimento.cCusto = null,
                this.comprometimento.idCronogramaDesembolso = 0,
                this.comprometimento.nuValorRateio = 0,
                this.cCustos = []
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    created() {
        this.obterCCustos()
    },

    watch: {
        // vcCodUnidade(){
        //     if(this.operacaoProp == 'I' || this.preenchido == true){
        //         this.obterProjetos(this.vcCodUnidade)
        //     }
        // },

        // vcCodProjeto(){
        //     if(this.operacaoProp == 'I' || this.preenchido == true){
        //         this.obterAcoes(this.vcCodProjeto)
        //     }
        // },
    },
}
</script>